import React, { useState, useEffect } from 'react';
import BaseInformationParams from '../types/BaseInformationParams';
import getText from '../api/getText';

const PolicyPolicyMain: React.FC = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    const fetchText = async () => {
      const params: BaseInformationParams = {
        type: 'privacy_policy',
        name: 'for_customer'
      }

      try {
        const response = await getText(params);

        setText(response.data.text);
      } catch (error) {
        console.error("Error fetching privacy policy data:", error);
      }
    };

    fetchText();
  }, []);

  return (
    <React.Fragment>
      <main id="page-facility_login" className="wrapper">
        <section className="sec-contact">
          <div className="inner">
            <h1 className="c-ttl__01">プライバシーポリシー</h1>
            <div className="contact-box">
              <div className="contact-box__left">
                <p className="c-txt__01 contact-box__txt" style={{ whiteSpace: 'pre-wrap' }}>{text}</p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default PolicyPolicyMain;
